import { render, staticRenderFns } from "./TaxReturnMaterialActiveSection.vue?vue&type=template&id=628e48bd&scoped=true&"
import script from "./TaxReturnMaterialActiveSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnMaterialActiveSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e48bd",
  null
  
)

export default component.exports